import { ISSUER_NO_VENDOR_SENTINEL } from 'features/evaluations/metadata/utils/evalCorpusFilters'
import type { DocumentPageMetadataUserEditEntry } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'

function nonemptyIssuer(value: string | null | undefined): string | undefined {
  if (value === undefined || value === null) return undefined
  const trimmed = value.trim()
  return trimmed === '' ? undefined : trimmed
}

/** Original corpus Vendor; legacy events may only have a saved snapshot. */
export function generatedIssuerOrValuesFallback(
  edit: DocumentPageMetadataUserEditEntry
): string | undefined {
  const generated = nonemptyIssuer(
    edit.entry.data.generated_values?.issuer_company_name
  )
  if (generated !== undefined) return generated
  return nonemptyIssuer(edit.entry.data.values?.issuer_company_name)
}

/** Explicitly clearing Vendor must not restore the pipeline's value. */
export function savedIssuerOrGeneratedFallback(
  edit: DocumentPageMetadataUserEditEntry
): string | undefined {
  const saved = edit.entry.data.values?.issuer_company_name
  return nonemptyIssuer(
    saved === undefined
      ? edit.entry.data.generated_values?.issuer_company_name
      : saved
  )
}

export function matchesIssuerFilter(
  issuer: string | undefined,
  issuers: readonly string[] | undefined
): boolean {
  if (issuers === undefined) return true
  if (issuers.length === 0) return false
  if (issuer === undefined) return issuers.includes(ISSUER_NO_VENDOR_SENTINEL)
  return issuers.includes(issuer)
}
